<template>
  <div id="files" style="background-color: #F4F6F8;min-height: 905px">
    <div class="productBack">
      <div style="width: 1280px;text-align: left;display: inline-block">
        <div class="title">文档资料</div>
        <div class="subTitle">
          全部文档与数据资料。
        </div>
      </div>
    </div>
    <div style="display: flex;justify-content: center">
      <div style="width: 1280px;padding: 24px;background: white;margin: 24px 0">
        <div style="margin-bottom: 10px">
          <span style="display: inline-block;margin-right: 10px">文件名称：</span>
          <Input v-model="nameStr" style="width: 200px" clearable/>
          <span style="display: inline-block;margin-left: 30px">标签：</span>
          <Select v-model="fileTag" clearable style="width:200px">
            <Option v-for="item in fileTagList" :value="item.value" :key="item.value" >{{ item.label }}</Option>
          </Select>
          <Button class="sureButton" style="margin-left: 20px" @click="getFileList()">确定</Button>
        </div>
        <div style="margin-top: 24px">
          <Table  height="700" :columns="filesColumns" :data="fileList">
            <template #tag="{ row, index }">
              <span v-if="row.tag==='helpBook'">帮助文档</span>
              <span v-if="row.tag==='pluginUnit'">插件文件</span>
              <span v-if="row.tag==='profile'">简介</span>
            </template>
            <template #action="{ row, index }">
              <div  @click="preview('file',row)" class="downButton">下载</div>
            </template>
          </Table>
        </div>


      </div>
    </div>


  </div>
</template>

<script>
import {
  searchFiles,
  listFileRelationStatus,
} from "../api"

export default {
  name: "videoList",
  data() {
    return {
      fileList: [],
      nameStr: '',
      categoryId: '',
      fileTag: '',
      addFileModal: false,
      showType: 'img',
      showSource: '',
      categoryList: [],
      fileData: {
        name: '',
        description: '',
        tag: 'helpBook',
        prior: '',
        fileId: '',
        categoryIds: [],
      },
      changeModal: false,
      fileRowData: '',
      changFile: '',
      delFileModal: false,
      bingsModal: false,
      bindType: '',
      bingsData: [],
      categoryName: '',

      fileTagList: [
        {
          value: 'helpBook',
          label: '帮助文档'
        },
        {
          value: 'pluginUnit',
          label: '插件'
        },
        {
          value: 'profile',
          label: '简介'
        },
      ],

      filesColumns:
        [
          {
            title: '名称',
            key: 'name',
            tree: true
          },
          {
            title: '描述',
            key: 'description'
          },


          {
            title: '标签',
            slot: 'tag',
            width: 150
          },
          {
            title: '操作',
            slot: 'action',
            width: 100,
            align: 'center'
          }
        ],
      bindsColumns:
        [
          {
            title: '名称',
            key: 'name',
          },
          {
            title: '状态',
            slot: 'bindState',
            width: 100,
          },
          {
            title: '操作',
            slot: 'action',
            width: 200,
            align: 'center'
          }
        ],
      fileChangeUploader: '',
      fileUploader: '',
      relationFileIdsList: '',
    }
  },
  methods: {
    getFileList() {
      searchFiles({
        type: 'file',
        name: this.nameStr,
        categoryId: this.categoryId,
        tag: this.fileTag
      }).then((res) => {
        if (res.data.result.success) {
          this.fileList = res.data.result.cmsFiles
        } else {
          this.$Message.error(res.data.result.info);
        }
      }).catch((error) => {
        console.log(error);
      });
    },





    preview(type, row) {
      this.showType = type;
      this.showSource = row.uri
      window.open(this.showSource)
      // const filename = row.name;
      // let a = document.createElement('a');
      // a.style.display='none'
      // a.href = this.showSource;
      // a.target="_blank"
      // a.setAttribute('download',filename)
      // document.body.appendChild(a)
      // a.click();
      // document.body.removeChild(a)
    },


  },
  mounted() {
    window.scrollTo(0, 0)
    this.getFileList()
  }
}


</script>


<style scoped lang="scss">
.productBack {
  width: 100%;
  height: 280px;
  background: url("../../static/img/file/fileBack.png");
  text-align: center;

  .title {
    font-weight: 600;
    font-size: 32px;
    color: #FFFFFF;
    margin-top: 118px;
  }

  .subTitle {
    width: 60%;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    margin-top: 8px;
  }
}

.innerModal {
  padding: 10px 20px;

  .modalText {
    margin-bottom: 10px;
  }
}
.sureButton{
  width: 60px;
  height: 32px;
  background: #0069E0;
  border-radius: 2px;
  font-weight: 500;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 18px;
}
.downButton{
  cursor: pointer;
  width: 64px;
  height: 28px;
  border-radius: 2px;
  border: 1px solid #3387E6;
  font-size: 12px;
  color: #0069E0;
  line-height: 26px;
}
</style>



// WEBPACK FOOTER //
// src/components/fileList.vue